(ns web3.components.icons
  (:refer-clojure :exclude [get])
  (:require [web3.icons.inline :as inline]))

;; see `web3.icons.inline` for hiccup-icons that
;; are compiled to .svg files at build-time
(def compiled-icon-keys inline/icon-keys)

(defn get
  "Returns inline svg for keywords (looked up in `inline-svg` above).
   if a string is provided, loads svg from /icons/<k>.svg into an img tag."
  ([k]
   (let [img-tag #(identity [:img {:alt (str "Icon of " %)
                                   :src (str "/icons/" % ".svg")}])

         get-or-link #(if (contains? compiled-icon-keys %)
                        [:img {:alt (str "Icon of " (name %))
                               :src (inline/public-path %)}]
                        (img-tag (name %)))]

     (cond (keyword? k) (get-or-link k)
           (string? k) (img-tag k)
           (vector? k) k)))

  ([k not-found]
   ;; I don't think this is used anywhere, keeping this in for now
   ;; to make sure.
   (throw (ex-info "icons/get does not support `not-found`" {:k k}))))

